/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//window.checkCookie=function(){
  
Shopify.formatMoney=function(a,e){var t=/\{\{\s*(\w+)\s*\}\}/;switch(e=e||this.money_format,"string"==typeof a&&(a=a.replace(/[^0-9]/g,"")),(a=(a=parseInt(a)).toString()).length){case 0:a="000";break;case 1:a="00"+a;break;case 2:a="0"+a}var r=a.substr(a.length-2),s=a.substr(0,a.length-2),n=",",c=".";switch(e.match(t)[1]){case"amount_no_decimals":r="",c="";break;case"amount_with_comma_separator":n=".",c=",";break;case"amount_no_decimals_with_comma_separator":n=".",r="",c=""}var o=function(a,e){return e=e||",",a.replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)}(s,n)+c+r;return e.replace(t,o)};

var currentValue = 0;
function onVariantChangeCustom(myRadioValue,variant_id) {
    
  var currentValue = myRadioValue.value;  
  //console.log(currentValue);
  var size_variant = currentValue.includes("Pack");
  var single_variant = currentValue.includes("Single");
  
  
  //document.getElementById("ProductMeta__PricePerItem").innerHTML = ' ';
  	if(single_variant == true){
      document.getElementById("ProductMeta__PricePerItem").innerHTML = ' ';
  	}else if(size_variant == true){
      
      var currentValue = currentValue.replace(/(^\d+)(.+$)/i,'$1');
      //var currentValue = currentValue.match(/\d/g);
      if(currentValue !== null){
       setTimeout(
        function() {
          var node = document.querySelector('.Product__Info .ProductMeta__PriceList > .ProductMeta__Price'),

          textContent = node.textContent;
          var priceNum = parseFloat(textContent.substring(1));
         console.log(myRadioValue.value);
          //if(myRadioValue.classList.contains('count-0')){
            if(myRadioValue.value.includes('Single')){
          
          //textContent);
//           if(priceNum == myRadioValue.value.split('$')[1]){
           	document.getElementById("ProductMeta__PricePerItem").innerHTML = ' ';
           }else{

            var item_price = priceNum / currentValue;   
            var item_price = Shopify.formatMoney(item_price * 100,window.theme.moneyFormat);
            document.getElementById("ProductMeta__PricePerItem").innerHTML = '('+item_price + ' Per Item)';
		  }
        }, 100);
        
      }
  	}
}


window.addEventListener('load', (event) => {
//    if($('.SizeSwatchList').hasClass('v_Pack')){
//     console.log('test');
//     }
  var regex = /[+-]?\d+(?:\.\d+)?/g;
  const packVariantClass = document.querySelector('.vv_Size');
  if(packVariantClass){
  if(packVariantClass.classList.contains('v_Pack')){
      
   var labelVariant = packVariantClass.querySelectorAll('.SizeSwatch');
    for (var i = 0, len = labelVariant.length; i < len; ++i) {
    	if(labelVariant[i].innerHTML.indexOf("Pack") !== -1) {

		var pack_size = labelVariant[i].innerText.split('-')[0];
          pack_size = pack_size.replace(/\D/g,'');
         var packprice = labelVariant[i].innerText.split('$')[1];
          
         // console.log(packprice);
          if(packprice){
    	 var each_price = packprice / pack_size;
          
           //console.log(each_price);
          each_price = Shopify.formatMoney(each_price * 100,window.theme.moneyFormat);
          //each_price = each_price.innerText.split('.')[0];
        // each_price= parseInt(each_price);
           var node = document.createElement("DIV");
          node.className = 'fs12';
          var textnode = document.createTextNode(each_price +'/each');
  			node.appendChild(textnode);
          labelVariant[i].appendChild(node);
            if (i === labelVariant.length - 1){ 
              
              var nodeBest = document.createElement("SPAN");
              nodeBest.className = 'best_value_item';
              var textnodeBest = document.createTextNode('Best value');
              nodeBest.appendChild(textnodeBest);
          labelVariant[i].appendChild(nodeBest);
            //labelVariant[i].appendChild(<span class="flag-angle"><span class="flag-angle__content">Best value</span></span>
            }
          }
    	}
    }    
  }
  }
});

